import { Entity } from "./Entity";
import { AppMenu } from "../HTML/Menu/AppMenu";

export class AppMenuManager extends Entity {

    public show(menuData: Array<Map<any, any>>) {
        const c: AppMenu = this.getAppContainer();
        c.addItems(menuData);
        c.show();
    }

    protected getAppContainer() {
        return this.get("appContainer");
    }

    protected initialize(data: any) {
        super.initialize(data);
        this.addToData("appContainer", new AppMenu(data));
    }
}
